import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { SaveIcon, InfoIcon, AlertCircleIcon } from 'lucide-react';
export function SollecitiAutomationsTab() {
  const [modalita, setModalita] = useState('standard');
  const [showAddForm, setShowAddForm] = useState(false);
  const [newTypeName, setNewTypeName] = useState('');
  const [config, setConfig] = useState({
    amichevole: {
      numeroSolleciti: 2,
      giorniAttesa: 7,
      avanzamentoAutomatico: true
    },
    formale: {
      numeroSolleciti: 2,
      giorniAttesa: 10,
      avanzamentoAutomatico: true
    },
    duro: {
      numeroSolleciti: 1,
      giorniAttesa: 7,
      avanzamentoAutomatico: true
    },
    pec: {
      giorniAttesa: 15,
      avanzamentoAutomatico: false
    }
  });
  const handleConfigChange = (fase, campo, valore) => {
    setConfig({
      ...config,
      [fase]: {
        ...config[fase],
        [campo]: valore
      }
    });
  };
  const handleModalitaChange = e => {
    setModalita(e.target.value);
  };
  const handleSaveConfig = () => {
    // Qui andrebbe la logica per salvare la configurazione
    alert('Configurazione salvata con successo');
  };
  // Descrizioni delle modalità
  const modalitaDescriptions = {
    manuale: "In modalità Manuale il sistema invia solo ciò che viene esplicitamente avviato dall'operatore e, allo scadere dei tempi, genera una notifica senza procedere oltre.",
    standard: "In modalità Standard l'invio dei solleciti all'interno della singola fase segue i parametri impostati, mentre il passaggio alla fase successiva avviene solo se l'operatore lo conferma oppure se è attivato il relativo flag di avanzamento.",
    automatico: "In modalità Automatico sia l'invio sia l'avanzamento tra le fasi sono governati dai parametri temporali e dai flag, senza necessità di intervento umano."
  };
  return <Card data-id="element-174">
      <h3 className="text-lg font-medium text-gray-900 mb-6" data-id="element-175">
        Configurazione Automazioni Solleciti
      </h3>
      <div className="mb-6" data-id="element-176">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-3 md:space-y-0" data-id="element-177">
          <div data-id="element-178">
            <label htmlFor="modalita" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-179">
              Modalità di funzionamento
            </label>
            <div className="flex items-center space-x-4" data-id="element-180">
              <select id="modalita" name="modalita" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" value={modalita} onChange={handleModalitaChange} data-id="element-181">
                <option value="manuale" data-id="element-182">Manuale</option>
                <option value="standard" data-id="element-183">Standard</option>
                <option value="automatico" data-id="element-184">Automatico</option>
              </select>
            </div>
            <p className="mt-2 text-sm text-gray-500" data-id="element-185">
              {modalitaDescriptions[modalita]}
            </p>
          </div>
        </div>
      </div>
      <div className="space-y-8" data-id="element-186">
        {/* Sollecito Amichevole */}
        <div className="bg-blue-50 p-4 rounded-lg" data-id="element-187">
          <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-188">
            Sollecito Amichevole
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-189">
            <div data-id="element-190">
              <label htmlFor="amichevole-num" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-191">
                Numero di solleciti da inviare
              </label>
              <input type="number" id="amichevole-num" min="1" max="5" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={config.amichevole.numeroSolleciti} onChange={e => handleConfigChange('amichevole', 'numeroSolleciti', parseInt(e.target.value))} data-id="element-192" />
            </div>
            <div data-id="element-193">
              <label htmlFor="amichevole-giorni" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-194">
                Giorni di attesa dopo l'ultimo invio
              </label>
              <input type="number" id="amichevole-giorni" min="1" max="30" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={config.amichevole.giorniAttesa} onChange={e => handleConfigChange('amichevole', 'giorniAttesa', parseInt(e.target.value))} data-id="element-195" />
            </div>
          </div>
          <div className="mt-4" data-id="element-196">
            <div className="flex items-center" data-id="element-197">
              <input id="amichevole-auto" name="amichevole-auto" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" checked={config.amichevole.avanzamentoAutomatico} onChange={e => handleConfigChange('amichevole', 'avanzamentoAutomatico', e.target.checked)} data-id="element-198" />
              <label htmlFor="amichevole-auto" className="ml-2 block text-sm text-gray-700" data-id="element-199">
                Abilita avanzamento automatico a Sollecito Formale
              </label>
            </div>
            <p className="mt-1 text-xs text-gray-500" data-id="element-200">
              Se disattivato, il sistema notificherà l'operatore e attenderà la
              conferma manuale
            </p>
          </div>
        </div>
        {/* Sollecito Formale */}
        <div className="bg-yellow-50 p-4 rounded-lg" data-id="element-201">
          <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-202">
            Sollecito Formale
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-203">
            <div data-id="element-204">
              <label htmlFor="formale-num" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-205">
                Numero di solleciti da inviare
              </label>
              <input type="number" id="formale-num" min="1" max="5" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={config.formale.numeroSolleciti} onChange={e => handleConfigChange('formale', 'numeroSolleciti', parseInt(e.target.value))} data-id="element-206" />
            </div>
            <div data-id="element-207">
              <label htmlFor="formale-giorni" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-208">
                Giorni di attesa dopo l'ultimo invio
              </label>
              <input type="number" id="formale-giorni" min="1" max="30" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={config.formale.giorniAttesa} onChange={e => handleConfigChange('formale', 'giorniAttesa', parseInt(e.target.value))} data-id="element-209" />
            </div>
          </div>
          <div className="mt-4" data-id="element-210">
            <div className="flex items-center" data-id="element-211">
              <input id="formale-auto" name="formale-auto" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" checked={config.formale.avanzamentoAutomatico} onChange={e => handleConfigChange('formale', 'avanzamentoAutomatico', e.target.checked)} data-id="element-212" />
              <label htmlFor="formale-auto" className="ml-2 block text-sm text-gray-700" data-id="element-213">
                Abilita avanzamento automatico a Sollecito Duro
              </label>
            </div>
            <p className="mt-1 text-xs text-gray-500" data-id="element-214">
              Se disattivato, il sistema notificherà l'operatore e attenderà la
              conferma manuale
            </p>
          </div>
        </div>
        {/* Sollecito Duro */}
        <div className="bg-orange-50 p-4 rounded-lg" data-id="element-215">
          <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-216">
            Sollecito Duro
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-217">
            <div data-id="element-218">
              <label htmlFor="duro-num" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-219">
                Numero di solleciti da inviare
              </label>
              <input type="number" id="duro-num" min="1" max="5" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={config.duro.numeroSolleciti} onChange={e => handleConfigChange('duro', 'numeroSolleciti', parseInt(e.target.value))} data-id="element-220" />
            </div>
            <div data-id="element-221">
              <label htmlFor="duro-giorni" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-222">
                Giorni di attesa dopo l'ultimo invio
              </label>
              <input type="number" id="duro-giorni" min="1" max="30" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={config.duro.giorniAttesa} onChange={e => handleConfigChange('duro', 'giorniAttesa', parseInt(e.target.value))} data-id="element-223" />
            </div>
          </div>
          <div className="mt-4" data-id="element-224">
            <div className="flex items-center" data-id="element-225">
              <input id="duro-auto" name="duro-auto" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" checked={config.duro.avanzamentoAutomatico} onChange={e => handleConfigChange('duro', 'avanzamentoAutomatico', e.target.checked)} data-id="element-226" />
              <label htmlFor="duro-auto" className="ml-2 block text-sm text-gray-700" data-id="element-227">
                Abilita avanzamento automatico a PEC Ufficiale
              </label>
            </div>
            <p className="mt-1 text-xs text-gray-500" data-id="element-228">
              Se disattivato, il sistema notificherà l'operatore e attenderà la
              conferma manuale
            </p>
          </div>
        </div>
        {/* PEC Ufficiale */}
        <div className="bg-purple-50 p-4 rounded-lg" data-id="element-229">
          <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-230">
            PEC Ufficiale
          </h4>
          <div data-id="element-231">
            <label htmlFor="pec-giorni" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-232">
              Giorni di attesa dopo l'invio della PEC
            </label>
            <input type="number" id="pec-giorni" min="1" max="60" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={config.pec.giorniAttesa} onChange={e => handleConfigChange('pec', 'giorniAttesa', parseInt(e.target.value))} data-id="element-233" />
            <p className="mt-1 text-xs text-gray-500" data-id="element-234">
              Dopo questo periodo, il sistema avvierà la procedura di recupero
              crediti tramite legale
            </p>
          </div>
          <div className="mt-4" data-id="element-235">
            <div className="flex items-center" data-id="element-236">
              <input id="pec-auto" name="pec-auto" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" checked={config.pec.avanzamentoAutomatico} onChange={e => handleConfigChange('pec', 'avanzamentoAutomatico', e.target.checked)} data-id="element-237" />
              <label htmlFor="pec-auto" className="ml-2 block text-sm text-gray-700" data-id="element-238">
                Abilita avanzamento automatico al recupero crediti legale
              </label>
            </div>
            <p className="mt-1 text-xs text-gray-500" data-id="element-239">
              Se disattivato, il sistema notificherà l'operatore e attenderà la
              conferma manuale
            </p>
          </div>
        </div>
      </div>
      <div className="mt-8 flex justify-end" data-id="element-240">
        <Button type="button" onClick={handleSaveConfig} icon={<SaveIcon className="h-4 w-4 mr-2" data-id="element-242" />} data-id="element-241">
          Salva Configurazione
        </Button>
      </div>
    </Card>;
}